import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-event-guest-dialog',
  templateUrl: './event-guest-dialog.component.html',
  styleUrls: ['./event-guest-dialog.component.scss']
})
export class EventGuestDialogComponent {

    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      console.log(JSON.stringify(this.data))
     }

}
